import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var OrderStages = React.createClass({

    getInitialState() {
        return {store: AvailabilityStore.getState()};
    },

    componentDidMount() {
        AvailabilityStore.listen(this.onChange);
    },

    componentWillUnmount() {
        AvailabilityStore.unlisten(this.onChange);
    },

    onChange(state) {
        this.setState({store: state});
    },

    render() {
        const { t } = this.props;
        var store = this.state.store;

        return (
            <div className="hidden-xs text-center orderstages container">
                <img src={store.get('install_path')+"/img/availability_steps_3.png"} />
            </div>
        );
    }
});

// OrderStages_tn

export default  translate('common', { wait: true })(OrderStages);

